import { forwardRef } from 'react';
import { CardElementProps, CardRef } from '@type/card';


// Card Header
// ***************************************************************
export const CardHeader = forwardRef<CardRef, CardElementProps>((props, ref) => {
  // destructure props
  const {
    className = '',
    children = 'Card header',
    ...restProps
  } = props;

  return (
    <div ref={ref} className={className || 'border-b p-3'} {...restProps}>
      { children }
    </div>
  );
});
